// import moment from 'moment';
import moment from 'moment-timezone';

class BaseMitReserveDateTimeService {
  constructor() {
      this.timeDurations = [
        {
            text:'15 Min',
            value:15
        },
        {
            text:'30 Min',
            value:30
        },
        {
            text:'45 Min',
            value:45
        },
        {
            text:'1 Hour',
            value:60
        },
        {
            text:'1.5 Hours',
            value:90
        },
        {
            text:'2 Hours',
            value:120
        },
        {
            text:'2.5 Hours',
            value:150
        },
        {
            text:'3 Hours',
            value:180
        },
        {
            text:'3.5 Hours',
            value:210
        },
        {
            text:'4 Hours',
            value:240
        },
    ];
  }
  isDateTimeFormatValid(dateTimeString){
    return (moment(dateTimeString, "YYYY-MM-DD HH:mm:ss", true).isValid() === true);
  }
  getDateStringNowLocal(){
    return moment().local().format('YYYY-MM-DD HH:mm:ss').toString();//default to now
  }

  getCurrentDayOfWeek(targetDateTime){
    return moment(targetDateTime).format('dddd').toLowerCase();
  }

  convertLocalTimeToUTCServerFormat(momentDateTime){
    return momentDateTime.utc().format("YYYY-MM-DD hh:mm A");
  }

  getMyTimezone(){
    return moment.tz.guess();
  }
  getTimezones(){
    return moment.tz.names();
  }

  getDefaultTimes(timeList, endOffsetMinutes, asMoment){
      let defaults = {
          start:null,
          end:null,
          duration:endOffsetMinutes
      };

      let startTime;

      if(moment().minute() === 0){
          startTime = moment();
      }
      else{
          startTime = moment().add( 30 - moment().minute() % 30, 'm');
          startTime.subtract(30, 'm');//Start 30 minutes before if we are not on the hour
      }

      if(asMoment){
          defaults.start = startTime;
          defaults.end = moment(startTime).add(endOffsetMinutes, 'm')
      }
      else{
          defaults.start = startTime.format("hh:mm A");
          defaults.end = startTime.add(endOffsetMinutes, 'm').format("hh:mm A");
      }


      return defaults;
  }

  getTimes() {
      let endTime = moment().endOf('day');
      let startTime = moment().startOf('day');

      let timeList = [];
      //let startTime = moment().add( 15 - moment().minute() % 15, 'm');
      //startTime.subtract(15, 'm');//Start 15 minutes before to make sure get the start time.

      while(startTime <= endTime){
          timeList.push(new moment(startTime).format("hh:mm A"));
          startTime.add(15, 'm');
      }

      //Add the last 15 minutes to get to end time.
      timeList.push(new moment(startTime).format("hh:mm A"));

      return timeList;
  }
  dateRangeConflict(moment1Start, moment1End, moment2Start, moment2End){
      // https://i.stack.imgur.com/0c6q0.png
      return (moment1Start < moment2End) && (moment2Start < moment1End)
  }

  checkDateConfictsInReservations(existingReservations, momentStart, momentEnd){
      for(let x = 0; x < existingReservations.length; x++){
          if(this.dateRangeConflict(existingReservations[x].startDateTime, existingReservations[x].endDateTime, momentStart, momentEnd) === true){
              return true;
          }
      }

      return false;
  }
  convertDateStringToMoment(date, format){
      format = format || 'YYYY-MM-DD';
      return new moment(date, format );
  }
  convertDateTimeStringToMoment(date, time){
      format = format || 'YYYY-MM-DD hh:mm A';
      return new moment(date + ' ' + time, format );
  }

  generateRecurringDates(startTime,endTime, durationMinutes, step, modifier){
      //step is the increment to add, used with modifier
      //modifier - can be 'day', 'week', 'month', 'year'
      let dates = [];
      let timeStart = new moment(startTime);//used to ensure we keep the same time across DST transitions
      let currentDate = new moment(startTime);
      let lastDate = new moment(endTime);

      let start,end;

      while(currentDate <= lastDate) {
            start = currentDate;
            end = new moment(currentDate).add(durationMinutes, 'm');
            //   dates.utcString.push({
            //     //IMPORTANT to create a new UTC moment out of the current calculation
            //     //We need to calculate in users timezone so taht we can keep their desired time,
            //     //the same across timezone transitions. At least with the pattern we are using now.
            //     //Obviously the downside of this is we are sort of hard coding DST transition information
            //     //into the recurring events, making it impossible to fix them if the DST transitions ever change again.
            //       startTime:new moment(start).utc().format('YYYY-MM-DD hh:mm A'),
            //       endTime:new moment(end).utc().format('YYYY-MM-DD hh:mm A')
            //   });

            dates.push({
                startTime:new moment(start),
                endTime: new moment(end)
            });

            currentDate = currentDate.add(step, modifier);
            //for case of DST transition, reset the time
            //For example this ADD will keep the time the same even though we went through DST
            //So in the case of going through a spring leap ahead, the UTC time will remain consistent
            //and cause the spring ahead to now be 1 hour off, 
            //It is critical to calculate these recurring dates in the users time zone so that the time in UTC gets
            //set correctly to match the offsets so that the local time remains constant.
            currentDate.set({
                hour:   timeStart.get('hour'),
                minute: timeStart.get('minute'),
                second: timeStart.get('second')
            });
      }

      return dates;
  }
  convertRecurringDatesListToUTCString(dateTimeList){
      let datesUTC = [];

      for(let x = 0; x < dateTimeList.length; x++){
        datesUTC.push({
            startTime:new moment(dateTimeList[x].startTime, 'YYYY-MM-DD hh:mm A').utc().format("YYYY-MM-DD hh:mm A"),
            endTime:new moment(dateTimeList[x].endTime, 'YYYY-MM-DD hh:mm A').utc().format("YYYY-MM-DD hh:mm A")
        });
      }

      return datesUTC;
  }

  convertRecurringDatesListToLocalMoment(dateTimeList){
    let dates = [];

    if(typeof dateTimeList === 'undefined' || dateTimeList === null){
        return [];
    }
    
    for(let x = 0; x < dateTimeList.length; x++){
        dates.push({
          startTime:new moment(dateTimeList[x].startTime).local(),
          endTime:new moment(dateTimeList[x].endTime).local()
      });
    }

    return datesUTC;
}


}
export default BaseMitReserveDateTimeService;
